const state = {
    
    blocks:[
        {
            id:1,
            name:'Stammdaten',
            color:'#fff',
            columns:2,
            blockcomponents: {
                columns: [
                    //left column
                    [
                        {
                            id:1,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Name",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte den Namen eingeben",
                                    icon:"edit",
                                    variable: 'name',
                                    setter: 'companies/COMPANY_SET_NAME',
                                    rules:"required"
                                    
                            }
                        },
                        {
                            id:2,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Additional Name",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte den Namenszusatz eingeben",
                                    icon:"edit",
                                    variable: 'additional_name',
                                    setter: 'companies/COMPANY_SET_ADDITIONAL_NAME'
                            }
                        },
                        {
                            id:3,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Web",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte die Homepage angeben",
                                    icon:"edit",
                                    variable: 'web',
                                    setter: 'companies/COMPANY_SET_WEB'
                            }
                        },
                         {
                            id:4,
                            name:'forminput',
                            attributes:{
                                    placeholder:"E-Mail",
                                    size:"xs8",
                                    invertedsize:"xs3",
                                    hint:"E Mail eingeben",
                                    icon:"edit",
                                    variable: 'email',                                    
                                    setter: 'companies/COMPANY_SET_EMAIL',
                                    rules:"required|email"
                                    
                            }

                        },                                                 
                    ],                   
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Kategorie auswählen",
                                size:"xs6",
                                invertedsize:"xs5",
                                displaytitle:"name",
                                displaysubtitle:"",
                                multiple:false,
                                icon:"search",
                                variable: 'companycategory_id',
                                setter: 'companies/COMPANY_SET_COMPANYCATEGORY',                                    
                                items:'companycategories/companycategories',
                                withdialog:false,
                                rules:"required"
                            }                                    
                        },                       
                        {
                            id:2,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Phone",
                                    size:"xs6",
                                    invertedsize:"xs5",
                                    hint:"Telelefon Nr eingeben",
                                    icon:"edit",
                                    variable: 'phone',
                                    setter: 'companies/COMPANY_SET_PHONE'
                            }
                        },
                        {
                            id:3,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Fax",
                                    size:"xs6",
                                    invertedsize:"xs5",
                                    hint:"Fax Nr eingeben",
                                    icon:"edit",
                                    variable: 'fax',
                                    setter: 'companies/COMPANY_SET_FAX'
                            }
                        },
                        {
                            id:4,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Mobile",
                                    size:"xs6",
                                    invertedsize:"xs5",
                                    hint:"Handy Nr eingeben",
                                    icon:"edit",
                                    variable: 'mobile',
                                    setter: 'companies/COMPANY_SET_MOBILE'
                            }
                        },
                        
                    ],                   
                ]
            }
        }
    ]

};

export default {
  namespaced: false,
  state,
  
};